module.exports = __webpack_public_path__ + "img/st-barts.72ef2ba8.svg";